import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react'
import swal from 'sweetalert'
import { useGetAllStationsQuery } from '../../Features/stationsSlice';
import Select from 'react-select';
import { useEditRouteMutation, useGetRouteByIdQuery } from '../../Features/RoutesSlice';
import { useGetSystemRegionsForRoutesQuery } from '../../Features/regionSlice';
import LoadingBar from "react-top-loading-bar";
import { useIsOnline } from 'react-use-is-online';

function EditRouteView() {
    const navigate = useNavigate();
    const { route_id } = useParams();

    const [start_off, setStart_off] = useState(false);
    const [destination, setDestination] = useState(false);
    const [region, setRegion] = useState({});
    const [progress, setProgress] = useState(0);
    const { isOnline } = useIsOnline();

    const [errors, setErrors] = useState({
        start_off: '',
        destination: '',
        region: '',
    })

    const {
        data: routes,
        isLoading,
        isSuccess,
        isError,
        error
      } = useGetAllStationsQuery()

      const {
        data: regions,
        isLoading: isLoadingRegions,
        isSuccess: isSuccessRegions,
        isError: isErrorRegions,
        error: errorRegions
      } = useGetSystemRegionsForRoutesQuery()

      const {
        data: route,
        isLoading: isLoadingRoute,
        isSuccess: isSuccessRoute,
        isError: isErrorRoute,
        error: ErrorRoute
      } = useGetRouteByIdQuery(route_id)

      useEffect(()=>{
        setProgress(30)
            if(isLoading){
                setProgress(60)
            }if(isLoadingRegions) {
                setProgress(75)
            }if(isLoadingRoute){
                setProgress(90)
            }if(isSuccess & isSuccessRegions & isSuccessRoute) {
                setProgress(100)
            }else{
                setProgress(100);
            }
            return () =>{
            }
        },[regions,route,routes])

    const [editRoute] = useEditRouteMutation();

    const handleSubmit = async(e)=>{
        e.preventDefault();
        if(!isOnline){
            return swal("No Internet connection",'Please check Internet connection and try again'); 
        }
        let data = '';
        if(!start_off || !destination || !region){
            data = {
                id: route.data.id,
                start_off: route.data.start_off_station_id,
                destination: route.data.destination_station_id,
                region: route.data.region_id
            }
        } else{
            data = {
                id: route.data.id,
                start_off: start_off.value,
                destination: destination.value,
                region: region.value,
            }
        }
        try {
            setProgress(80)
            const resp = await editRoute(data).unwrap()
            if(resp.hasOwnProperty('success') == true){
                setProgress(100)
                return navigate(-1);
            }
        } catch (err) {
            setProgress(100)
            if(err.data.hasOwnProperty('errors') == true){
                setErrors({...errors, 
                    start_off: err.data.errors.start_off, 
                    destination: err.data.errors.destination,
                    region: err.data.errors.region
                })
            }else if (err.data.hasOwnProperty('error') == true){
                setProgress(100)
                swal("Error",err.data.error,"error");
            }
        }           
    }
    const back = ()=> {
        if(!isOnline){
            return swal("No Internet connection",'Please check Internet connection and try again'); 
        }
        setProgress(80)
        navigate(-1)
    };

    return (
            <div className="md:w-2/5 mb-12">
                <LoadingBar
                color="#14b8a6"
                height="4px"
                progress={progress}
                onLoaderFinished={() => setProgress(0)}
                />
                {
                    (isSuccess && isSuccessRegions && isSuccessRoute)?
                        <div class="bg-white shadow-md rounded-md flex flex-col justify-center">
                                <div class="p-3">
                                    <form onSubmit={handleSubmit} autoComplete="off" >
                                        <div class="divide-y divide-gray-200">
                                            <div class="py-8 text-base leading-6 space-y-4 text-gray-700 sm:text-lg sm:leading-7">
                                            <div class="col-span-6 sm:col-span-3 spax">
                                                <label for="name" class="block p-2 text-xs text-gray-500">Pick up</label>
                                                <Select 
                                                    class=""
                                                    placeholder='Search...'
                                                    options={routes}
                                                    isSearchable
                                                    onChange={setStart_off}
                                                />
                                                <p className="block text-sm font-medium text-red-600 p-0 m-0">{errors.start_off}</p>
                                            </div>
                                            <div class="col-span-6 sm:col-span-3 spax">
                                                <label for="name" class="block p-2 text-xs text-gray-500">Destination</label>
                                                <Select 
                                                    class=""
                                                    placeholder='Search...'
                                                    options={routes}
                                                    isSearchable
                                                    onChange={setDestination}
                                                />
                                                <p className="block text-sm font-medium text-red-600 p-0 m-0">{errors.start_off}</p>
                                            </div>
                                            <div class="col-span-6 sm:col-span-3 spax">
                                                <label for="name" class="block p-2 text-xs text-gray-500">Region</label>
                                                <Select 
                                                    class=""
                                                    placeholder='Search...'
                                                    options={routes}
                                                    isSearchable
                                                    onChange={setRegion}
                                                />
                                                <p className="block text-sm font-medium text-red-600 p-0 m-0">{errors.start_off}</p>
                                            </div>
                                            <div class="flex items-center p-2 justify-between space-x-3 w-full border-t  border-gray-200">
                                                <div class="flex flex-col space-y-2 text-gray-400 flex-wrap w-2/3">
                                                    <label class="text-gray-500 text-sm">Delete route</label>
                                                    <div class="text-sm">You can delete this route permanently.</div>
                                                </div>
                                                <div class="flex justify-end text-sm">
                                                    <div className='px-x-2 text-green-500 font-bold uppercase cursor-pointer rounded-md'>Delete</div>
                                                </div>
                                            </div>
                                            </div>
                                            <div class="pt-4 flex items-end space-x-4">
                                                <div onClick={back} class="flex cursor-pointer hover:bg-gray-50 justify-center items-center w-full text-gray-900 px-4 py-3 rounded-md focus:outline-none">
                                                    Cancel
                                                </div>
                                                <button type='submit' class="bg-green-500 flex justify-center items-center w-full text-white px-4 py-3 rounded-sm hover:shadow-md focus:outline-none">Save</button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                    :null
                }
            </div>
        )

}

export default EditRouteView;
